export const HIGHARC_DEMO_ACCOUNT_PRIVILEGED_ADMIN_DENIED_MESSAGE =
  "Demo accounts cannot be invited as Super Admins. These accounts can only be invited to non-customer builders accounts.";

/** Matches internal demo logins such as demo1@higharc.com, demo2@higharc.com etc.. */
export function isHigharcDemoAccountEmail(email: string): boolean {
  return /^demo\d+@higharc\.com$/i.test(email.trim());
}
